import React from "react";
import styled from "styled-components";
import { FontWeight } from "@glossy";
import Tooltip, { Placement } from "@ui-kit/tooltip";

interface IProps {
  title?: React.ReactNode;
  content: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  placement?: Placement;
  disabled?: boolean;
}

const Root = styled.div`
  max-width: 300px;
`;

const Header = styled.div`
  font-weight: ${FontWeight.Bold};
`;

const Content = styled.div`
  font-weight: ${FontWeight.Normal};
`;

const Footer = styled.div`
  font-size: 12px;
`;

export const Inner = ({ title, content, footer }: Partial<IProps>) => (
  <Root>
    {!!title && <Header>{title}</Header>}
    {<Content>{content}</Content>}
    {!!footer && <Footer>{footer}</Footer>}
  </Root>
);

const UiKitTooltipDescription = ({
  title,
  content,
  footer,
  children,
  placement,
  disabled,
}: IProps) => (
  <Tooltip
    tooltip={<Inner {...{ title, content, footer }} />}
    disabled={disabled}
    placement={placement}
  >
    {children}
  </Tooltip>
);

export default UiKitTooltipDescription;
